import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  ButtonGroup,
  Stack,
  Typography
} from '@mui/material';

import TransactionListTable from 'src/components/transactions/TransactionListTable';
import { DATE_FORMAT, TRANSACTION_TYPES } from 'src/utils/constants';
import { getStoredUserTimezone, nowInTimezone } from 'src/utils/timezoneUtils';

const DATE_RANGES = [
  { id: 'today', label: 'Today' },
  { id: 'yesterday', label: 'Yesterday' }
];

export const getTankTransactionDateRange = (rangeId) => {
  const now = nowInTimezone(getStoredUserTimezone()).seconds(0).milliseconds(0);
  const start = rangeId === 'yesterday'
    ? now.clone().subtract(1, 'day').startOf('day')
    : now.clone().startOf('day');
  const end = rangeId === 'yesterday' ? start.clone().endOf('day') : now;

  return {
    start: start.format(DATE_FORMAT.unixDateTime),
    end: end.format(DATE_FORMAT.unixDateTime)
  };
};

function TankTransactions({ tankId, siteId }) {
  const [rangeId, setRangeId] = useState('today');
  const dateFilter = useMemo(() => getTankTransactionDateRange(rangeId), [rangeId]);

  return (
    <Stack spacing={2} sx={{ flex: 1, minHeight: 0 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1.5}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        justifyContent="space-between"
        sx={{ flexShrink: 0 }}
      >
        <Box>
          <Typography variant="h6" fontWeight={800}>
            Issued Transactions
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Fuel issued from this tank
          </Typography>
        </Box>
        <ButtonGroup size="small" variant="outlined" aria-label="Transaction date range">
          {DATE_RANGES.map((range) => (
            <Button
              key={range.id}
              variant={rangeId === range.id ? 'contained' : 'outlined'}
              onClick={() => setRangeId(range.id)}
              sx={{ textTransform: 'none', fontWeight: 700 }}
            >
              {range.label}
            </Button>
          ))}
        </ButtonGroup>
      </Stack>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          height: '100%',
          overflow: 'auto'
        }}
      >
        <TransactionListTable
          isSales
          searchText=""
          dateFilter={dateFilter}
          siteFilter={siteId || 'all'}
          tankFilter={tankId}
          transactionTypeOverride={TRANSACTION_TYPES[0].id}
        />
      </Box>
    </Stack>
  );
}

TankTransactions.propTypes = {
  tankId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default TankTransactions;
